import React from 'react'
import Masonry from 'react-masonry-css'
import { Box } from '@mui/material';
import CardComp from './Card';
import '../App.css'

const MasonryComp = ({articles}) => {

    const breakpoints = {
        default: 3,
        800: 3,
        700: 2,
        600: 1
    }
  return (

    <div>
        <Box>
            <Masonry
                breakpointCols={breakpoints}
                className="my-masonry-grid"
                columnClassName="my-masonry-grid_column"
            >
               {articles.map( (article) => (
                   <div key={article.id}>
                        <CardComp article={article} />
                    </div>
                ) )} 
            </Masonry>
        </Box>
    </div>

)
}

export default MasonryComp